<script>
import { defaultSeparator, getPageMetadata, mapMetaTag } from '../../libs/metadata'
import { getArticleMetaDescription } from '../../libs/article'

export default {
  computed: {
    /**
     * Metadata authors
     * @returns {string}
     */
    metaAuthors() {
      if (Array.isArray(this.article.authors)) {
        return this.article.authors.join(', ')
      }
      return ''
    },

    /**
     * Metadata description
     * @returns {string}
     */
    metaDescription() {
      return getArticleMetaDescription(this.article)
    },

    /**
     * Metadata cover image
     * @returns {[string]}
     */
    metaImages() {
      if (this.article && this.article.coverImage) {
        return [this.article.coverImage]
      }
      return []
    },

    /**
     * Metadata keywords
     * @returns {string}
     */
    metaKeywords() {
      if (Array.isArray(this.article.tags)) {
        return this.article.tags.join(', ')
      }
      return ''
    },

    /**
     * Metadata title
     * @returns {string}
     */
    metaTitle() {
      if (this.article.title) {
        return `${this.article.title} ${defaultSeparator} ${this.$t('metadata.titleSubfix')}`
      }
      return ''
    },

    /**
     * schema.org Article entity,
     * ref: https://developers.google.com/search/docs/data-types/article
     */
    schemaArticle() {
      const article = {
        '@context': 'https://schema.org',
        '@type': this.article.schemaType || 'Article',
        headline: this.article.title || '',
        mainEntityOfPage: `${process.env.SEEKER_WEB__BASE_URL}${this.$route.path}`,
        publisher: {
          '@type': 'Organization',
          name: this.$t('metadata.titleSubfix'),
        },
      }

      if (this.metaImages.length) {
        article.image = this.metaImages
      }
      if (this.article.createdAt) {
        article.datePublished = this.article.createdAt
      }
      if (this.article.lastUpdatedAt) {
        article.dateModified = this.article.lastUpdatedAt
      }
      if (Array.isArray(this.article.authors) && this.article.authors.length) {
        article.author = this.article.authors
          .filter((author) => author)
          .map((author) => ({
            '@type': 'Person',
            name: author,
          }))
      }

      return article
    },
  },
  head() {
    const metadata = {
      ...getPageMetadata(
        this.metaTitle,
        this.metaDescription,
        this.metaImages,
        this.metaKeywords,
        true, // Override default share image
      ),
      script: [
        {
          hid: 'article',
          json: this.schemaArticle,
          type: 'application/ld+json',
        },
      ],
    }
    if (this.metaAuthors) {
      metadata.meta.push(mapMetaTag('author', this.metaAuthors, 'author'))
    }
    return metadata
  },
  props: {
    /**
     * Article data
     */
    article: {
      required: true,
      type: Object,
    },
  },
  /**
   * Render nothing
   */
  render() {
    return null
  },
}
</script>
